module.exports = __webpack_public_path__ + "img/Tamale Meal.b22bffff.jpg";